import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIUyQuyen = {
  LIST_UY_QUYEN: `${BASE_API_URL_CAP_DIEN}/uy-quyen/list`,
  CREATE_UY_QUYEN: `${BASE_API_URL_CAP_DIEN}/uy-quyen/create`,
  UPDATE_UY_QUYEN: `${BASE_API_URL_CAP_DIEN}/uy-quyen/update`,
  REMOVE_UY_QUYEN: `${BASE_API_URL_CAP_DIEN}/uy-quyen/delete`,
  LIST_NGUOI_DUOC_UY_QUYEN: `${BASE_API_URL_CAP_DIEN}/uy-quyen/list-nguoi-duoc-uy-quyen`,
};
